<template>
  <form action="#" class="newsletter" v-on:submit="signup">
    <div v-bind:class="form_group_class">
      <div class="input-group">
        <input type="text" class="form-control" placeholder="jon.doe@dinwebb.se" name="email" v-bind:disabled="sending" v-model="email" />
        <span class="input-group-btn">
          <button type="submit" class="btn" v-bind:disabled="sending">{{label}}</button>
        </span>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  name: 'NewsletterSignup',
  data () {
    return {
      email: '',
      sending: false,
      label_default: 'SKICKA',
      label_sending: 'SKICKAR'
    }
  },
  methods: {
    signup (e) {
      var that = this
      this.sending = true

      setTimeout(function () {
        that.sending = false
        that.email = ''
      }, 1000)

      e.preventDefault()
    },
    validateEmail () {
      // eslint-disable-next-line
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(this.email).toLowerCase())
    }
  },
  computed: {
    label () {
      if (this.sending) {
        return this.label_sending
      } else {
        return this.label_default
      }
    },
    form_group_class () {
      var state = ''
      if (this.email !== '') {
        if (this.validateEmail()) {
          state = 'has-success'
        } else {
          state = 'has-error'
        }
      }
      return 'form-group ' + state
    }
  }
}
</script>

<style lang="scss">
@import "./src/util";

.newsletter {
  $line_height: 16px;

  .form-control[disabled] {
    background: #000;
    color: #fff;
    border-color: $cl_blue;
  }

  .btn {
    @include button-variant(#fff, $cl_blue, transparent)
    @include button-size(($input-height-base / 2 - $line-height / 2 - 1px), $header_link_padding, 14px, $line_height, 0px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NewsletterSignup.vue